import ct from 'countries-and-timezones';
import { LANGUAGES_CODES } from 'imports/generator/api/constants';
import { AiSelectWon, cdnFile, cdnTemplateImage, NEW_SYMBOL_PLACEMENT_LOCALE, staticFile } from 'lib/helpers';
import moment from 'moment-timezone';

export const getStripeSCAEnabled = () => {
  return true;
};

export const getTimezone = () => {
  return moment.tz.guess(true);
};

export const getCountry = () => {
  const timeZone = moment.tz.guess(true);
  const { countries = [''] } = ct.getTimezone(timeZone) || {};
  return countries?.[0];
};

export const getCountryName = () => {
  const timeZone = moment.tz.guess(true);
  const tz = ct.getTimezone(timeZone);
  const { name: country } = ct.getCountry(tz.countries?.[0]);
  return country;
};

/**
 * Formats a number to currency parts for fr
 */
export const helperCurrencyFormatterFR = (price, currency) => {
  const splitCurrency = parseFloat(price, 10).toFixed(2).toString().split('.');
  const integer = splitCurrency[0];
  const fraction = splitCurrency[1];
  switch (currency) {
    case 'CNY':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '¥' },
      ];

    case 'CLP':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
        { type: 'currency-postfix', value: 'CLP' },
      ];

    case 'VND':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.') },
        { type: 'currency-postfix', value: '₫' },
      ];
    case 'PEN':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'S/' },
      ];
    case 'PYG':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
        { type: 'currency-postfix', value: '₲' },
      ];
    case 'CHF':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'CHF' },
      ];
    case 'ILS':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '₪' },
      ];
    case 'THB':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '฿' },
      ];
    case 'BRL':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$R' },
      ];
    case 'RUB':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '₽' },
      ];
    case 'CZK':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'Kč' },
      ];
    case 'NOK':
    case 'SEK':
    case 'DKK':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'kr' },
      ];
    case 'SAR':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'SAR' },
      ];
    case 'AED':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'AED' },
      ];
    case 'PHP':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '₱' },
      ];
    case 'HUF':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'Ft' },
      ];
    case 'TRY':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '₺' },
      ];
    case 'HKD':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'HK$' },
      ];
    case 'ARS':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$AR' },
      ];
    case 'PLN':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'zł' },
      ];
    case 'MXN':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$MX' },
      ];
    case 'SGD':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$S' },
      ];
    case 'CAD':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$C' },
      ];
    case 'NZD':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$NZ' },
      ];
    case 'EUR':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: ',' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '€' },
      ];
    case 'GBP':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '£' },
      ];
    case 'AUD':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$AU' },
      ];
    case 'INR':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '₹' },
      ];
    case 'EGP':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'LE' },
      ];
    case 'ZAR':
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'R' },
      ];
    case 'COP':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') },
        { type: 'currency-postfix', value: '$COP' },
      ];
    case 'IDR':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') },
        { type: 'decimal', value: ',' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: 'Rp' },
      ];
    case 'JPY':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
        { type: 'currency-postfix', value: '¥' },
      ];
    case 'KRW':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
        { type: 'currency-postfix', value: '₩' },
      ];
    case 'USD':
    default:
      return [
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
        { type: 'currency-postfix', value: '$' },
      ];
  }
};

export const helperINRCurrencyFormatter = (integer, fraction) => {
  return [
    { type: 'currency', value: '₹' },
    {
      type: 'integer',
      value: integer.replace(/\B(?=(\d{3})(?=\d{2})*$)/g, ','),
    },
    { type: 'decimal', value: fraction ? '.' : '' },
    { type: 'fraction', value: fraction || '' },
  ];
};

/**
 * Formats a number to currency parts.
 */
export const helperCurrencyFormatter = (price, currency, locale, host = '') => {
  if (NEW_SYMBOL_PLACEMENT_LOCALE.includes(locale)) return helperCurrencyFormatterFR(price, currency);
  const splitCurrency = parseFloat(price, 10).toFixed(2).toString().split('.');
  const integer = splitCurrency[0];
  const fraction = splitCurrency[1];
  if (host === 'resumetiger' && currency == 'INR') return helperINRCurrencyFormatter(integer, fraction);
  switch (currency) {
    case 'CNY':
      return [
        { type: 'currency', value: '¥' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];

    case 'CLP':
      return [
        { type: 'currency', value: 'CLP' },
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
      ];

    case 'VND':
      return [
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.') },
        { type: 'currency', value: '₫' },
      ];
    case 'PEN':
      return [
        { type: 'currency', value: 'S/' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'PYG':
      return [
        { type: 'currency', value: '₲' },
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
      ];
    case 'CHF':
      return [
        { type: 'currency', value: 'CHF' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'ILS':
      return [
        { type: 'currency', value: '₪' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'THB':
      return [
        { type: 'currency', value: '฿' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'BRL':
      return [
        { type: 'currency', value: 'R$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'RUB':
      return [
        { type: 'currency', value: '₽' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'CZK':
      return [
        { type: 'currency', value: 'Kč' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'NOK':
    case 'DKK':
    case 'SEK':
      return [
        { type: 'currency', value: 'kr' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'SAR':
      return [
        { type: 'currency', value: 'SAR' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'AED':
      return [
        { type: 'currency', value: 'AED' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'PHP':
      return [
        { type: 'currency', value: '₱' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'HUF':
      return [
        { type: 'currency', value: 'Ft' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'TRY':
      return [
        { type: 'currency', value: '₺' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'HKD':
      return [
        { type: 'currency', value: 'HK$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'ARS':
      return [
        { type: 'currency', value: 'AR$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'PLN':
      return [
        { type: 'currency', value: 'zł' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'MXN':
      return [
        { type: 'currency', value: 'MX$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'SGD':
      return [
        { type: 'currency', value: 'S$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'CAD':
      return [
        { type: 'currency', value: 'C$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'NZD':
      return [
        { type: 'currency', value: 'NZ$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'EUR':
      return [
        { type: 'currency', value: '€' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: ',' },
        { type: 'fraction', value: fraction },
      ];
    case 'GBP':
      return [
        { type: 'currency', value: '£' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'AUD':
      return [
        { type: 'currency', value: 'AU$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'INR':
      return [
        { type: 'currency', value: '₹' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'EGP':
      return [
        { type: 'currency', value: 'LE' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'ZAR':
      return [
        { type: 'currency', value: 'R' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
    case 'COP':
      return [
        { type: 'currency', value: 'COP$' },
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') },
      ];
    case 'IDR':
      return [
        { type: 'currency', value: 'Rp' },
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') },
        { type: 'decimal', value: ',' },
        { type: 'fraction', value: fraction },
      ];
    case 'JPY':
      return [
        { type: 'currency', value: '¥' },
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
      ];
    case 'KRW':
      return [
        { type: 'currency', value: '₩' },
        { type: 'integer', value: integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') },
      ];
    case 'USD':
    default:
      return [
        { type: 'currency', value: '$' },
        { type: 'integer', value: integer },
        { type: 'decimal', value: '.' },
        { type: 'fraction', value: fraction },
      ];
  }
};

/**
 * Formats a number to currency with Intl.
 */
export const formatCurrency = (amount, currency, locale) => {
  const formatter = helperCurrencyFormatter(amount?.toFixed(2), currency, locale);

  const values = formatter?.map((t) => t.value);
  return values?.join('');
};

export const getTemplateImageUrlForPreview = (template, language, isMobile) => {
  const templateWithoutStaticImage = ['montecarlo', 'kiev', 'sf', 'vladivostok', 'shanghai'];
  if (templateWithoutStaticImage.includes(template)) language = 'en';
  const staticImageLocale = Object.values(LANGUAGES_CODES).filter(
    (lang) =>
      !['en', 'ar', 'kk', 'pt', 'sr', 'tj', 'ca', 'az', 'nl', 'he', 'hi', 'bn', 'uz', 'uk', 'fa'].includes(lang),
  );
  const AiSelectionTemplates = ['budapest', 'brunei', 'chicago', 'prague', 'riga', 'rotterdam', 'sydney', 'perth'];
  const showDefaultEnglishTemplate = ['hy', 'is'];
  const BruneiImageThere = ['en', 'ar', 'fr', 'tr', 'pt-br', 'es'];

  if (showDefaultEnglishTemplate.includes(language) && template !== 'brunei') {
    return cdnFile(`resumes/${template}.jpg`);
  }

  if (template === 'atsresume') {
    if (isMobile) {
      return cdnTemplateImage(`resume-images/resume/${language}/ATSWithImage.jpg`);
    } else {
      return cdnTemplateImage(`resume-images/resume/${language}/ATS.jpg`);
    }
  }

  if (template === 'oslo') {
    if (['en', 'es', 'fr', 'tr'].includes(language)) {
      return cdnTemplateImage(`resume-images/resume/${language}/OsloWithImage.jpg`);
    } else {
      return cdnTemplateImage(`resume-images/resume/en/Oslo.jpg`);
    }
  }

  if (AiSelectWon.includes(language) && AiSelectionTemplates.includes(template)) {
    return staticFile(`img/resumeai/${language}/${template}.jpg`);
  }
  if (template === 'brunei' && BruneiImageThere.includes(language)) {
    return staticFile(`img/resume/${language}/brunei.jpg`);
  }
  if (template === 'brunei') {
    return staticFile(`img/resume/en/brunei.jpg`);
  }
  if (staticImageLocale.includes(language) && !templateWithoutStaticImage.includes(template)) {
    return staticFile(`img/resume/${language}/${template}.jpg`);
  }
  return cdnFile(`resumes/${template}.jpg`);
};
